module.exports = __webpack_public_path__ + "img/fedex1.b34a28aa.png";